// apps/web/src/lib/showcase/skin.queries.ts
import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import type { Skin } from "./skin";

const COOKIE = "demo_skin";

export const $readSkinCookie = createServerFn({ method: "GET" }).handler(
  (): Skin => {
    const v = getCookie(COOKIE);
    return v === "heritage" ? "heritage" : "modern";
  }
);
